<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-card class="box no-display">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Monthly Paysheet Summary Report - 2</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><b>Salary Month</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month"
              :items="sal_month_list" item-text="name" item-value="id" label="Salary Month" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Employee Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type"
              :items="employee_type_list" item-text="name" item-value="id" label="Employee Type" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Designation</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="designation"
              :items="designation_list" item-text="name" item-value="id" label="Designation" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
              item-text="name" item-value="id" label="Employee" outlined />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" v-if="sal_month" @click="fetchSalaryRegister(); loader = true">
              Fetch Report
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
<v-row dense justify="center" v-if="emp_salary_reg_detail.length > 0">
                    <v-col sm="4" md="4">
                        <v-autocomplete clearable rounded outlined dense v-model="search" :items="emp_salary_reg_detail"
                            item-text="emp_section" label="Search Section" persistent-hint single-line></v-autocomplete>
                    </v-col>
                </v-row>
      <v-row dense class="mb-3" justify="center" v-if="emp_salary_reg_detail.length > 0">
        
        <v-col cols="12" sm="6" md="3">
          <v-btn rounded color="success" outlined @click="fnExcelReport" class="no-display">
            <v-icon color="success">mdi-export</v-icon> Export
          </v-btn>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-btn rounded color="warning" outlined @click="printReport" class="no-display">
            <v-icon>mdi-printer</v-icon> Print
          </v-btn>
        </v-col>
      </v-row>

      <div id="print-area" v-if="emp_salary_reg_detail.length > 0">
        <div ref="myTable" id="my-table-id">
          <v-simple-table fixed-header dense class="elevation-1 report-table">
            <thead>
              <tr>
                <td rowspan="2" class="text-center">Sr.No.</td>
                <td rowspan="2" class="text-center" style="width: 30%;">
                  Name<br /><br />
                  Designation<br /><br />
                  Date of joining
                </td>
                <td rowspan="2" class="text-center">Section</td>
                <td rowspan="2" class="text-center">Bank A/C No.</td>
                <td rowspan="2" class="text-center">
                  No.Of<br />Day's
                </td>
                <td class="text-center" v-for="(earnheader, i) in comp_header_earn" :key="i" v-if="i % 2 == 0">
                  {{ earnheader }}
                </td>
                <td rowspan="2" class="text-center">Gross Salary</td>
                <td rowspan="2" class="text-center">PF A/C</td>
                <td class="text-center" v-for="(deduheader, k) in comp_header_dedu" :key="k" v-if="k % 2 == 0">
                  {{ deduheader }}
                </td>
                <td rowspan="2" class="text-center">
                  Tot<br />Deduction
                </td>
                <td rowspan="2" class="text-center">Net Salary</td>
                <td rowspan="2">
                  Stamp &<br />Sig.
                </td>
              </tr>
              <tr>
                <td class="text-center" v-for="(earnheader, i) in comp_header_earn" :key="i" v-if="i % 2 == 1">
                  {{ earnheader }}
                </td>
                <td v-if="comp_header_earn.length % 2 == 1"></td>
                <td class="text-center" v-for="(deduheader, k) in comp_header_dedu" :key="k" v-if="k % 2 == 1">
                  {{ deduheader }}
                </td>
                <td v-if="comp_header_dedu.length % 2 == 1"></td>
              </tr>
            </thead>
            <tbody v-for="(s, index) in filteredSortSearchList" :key="index">
              <tr>
                <td rowspan="2" class="text-center">{{ index + 1 }}</td>
                <td rowspan="2" class="text-left pl-2">
                  {{ s.emp_name }} <br /><br />
                  {{ s.emp_designation }} <br /><br />
                  {{ s.date_of_joining }}
                </td>
                <td rowspan="2" class="text-center">{{ s.emp_section }}</td>
                <td rowspan="2" class="text-center">{{ s.emp_bank_ac_no }}</td>
                <td rowspan="2" class="text-center">{{ s.emp_working_days }}</td>
                <td class="text-center" v-for="(earnvalue, i) in s.comp_value_earn" :key="i" v-if="i % 2 == 0">
                  {{ earnvalue.s_value }}
                </td>
                <td rowspan="2" class="text-center">{{ s.gross_salary }}</td>
                <td rowspan="2" class="text-center">{{ s.emp_pf_no }}</td>
                <td class="text-center" v-for="(deduvalue, k) in s.comp_value_dedu" :key="k" v-if="k % 2 == 0">
                  {{ deduvalue.s_value }}
                </td>
                <td rowspan="2" class="text-center">{{ s.gross_deductions }}</td>
                <td rowspan="2" class="text-center">{{ s.net_salary }}</td>
                <td rowspan="2"></td>
              </tr>
              <tr>
                <td class="text-center" v-for="(earnvalue, i) in s.comp_value_earn" :key="i" v-if="i % 2 == 1">
                  {{ earnvalue.s_value }}
                </td>
                <td v-if="comp_header_earn.length % 2 == 1"></td>
                <td class="text-center" v-for="(deduvalue, k) in s.comp_value_dedu" :key="k" v-if="k % 2 == 1">
                  {{ deduvalue.s_value }}
                </td>
                <td v-if="comp_header_dedu.length % 2 == 1"></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </div>
    </v-container>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";

export default {
  components: { Breadcrumbs },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    sal_month_list: [],
    employee_type_list: [],
    employee_list: [],
    designation_list: [],
    sal_month: null,
    employee_type: null,
    employee: null,
    designation: null,
    comp_header_earn: [],
    comp_header_dedu: [],
    emp_salary_reg_detail: [],
    overlay: false,
    search: null,
  }),

  computed: {
    filteredSortSearchList() {
      const list = this.search
        ? this.emp_salary_reg_detail.filter(item =>
            item.emp_section.toLowerCase().includes(this.search.toLowerCase())
          )
        : [...this.emp_salary_reg_detail];
      return list.sort((a, b) => a.emp_name.localeCompare(b.emp_name));
    },
  },

  methods: {
    fnExcelReport() {
      const table = this.$refs.myTable;
      if (!table) {
        this.showSnackbar("#b71c1c", "Table not found!");
        return;
      }

      const tableHTML = table.innerHTML;
      const data = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head><meta charset="UTF-8"></head><body>
        <table border="1" style="border-collapse: collapse;">${tableHTML}</table></body></html>`;

      const blob = new Blob([data], { type: "application/vnd.ms-excel" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "MonthlyPaySheetSummaryReport2.xls";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    printReport() {
      this.$store.state.drawer = false;
      setTimeout(() => {
        window.print();
        setTimeout(() => {
          this.$store.state.drawer = true;
        }, 500);
      }, 200);
    },

    fetchSalaryRegister() {
      this.emp_salary_reg_detail = [];
      this.comp_header_earn = [];
      this.comp_header_dedu = [];

      const data = {
        sal_month: this.sal_month,
        employee_type: this.employee_type,
        designation: this.designation,
        employee: this.employee,
      };

      this.overlay = true;
      axios
        .post("/Payroll/fetchMonthlyPaySheetSummaryReport_2", data)
        .then((res) => {
          if (res.data.flag === "YES") {
            this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
            this.comp_header_earn = res.data.comp_header_earn;
            this.comp_header_dedu = res.data.comp_header_dedu;
          } else if (res.data.flag === "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar || "No data found");
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            if (res.data.error_trace) sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          console.error(error);
          this.showSnackbar("#b71c1c", "Network error!");
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },

    onLoad() {
      axios
        .post("/Payroll/getInitialData")
        .then((res) => {
          if (res.data.flag === "YES") {
            this.sal_month_list = res.data.sal_month_list;
            this.employee_type_list = res.data.employee_type_list;
            this.employee_list = res.data.instlist || [];
            this.designation_list = res.data.designation_list;
          } else {
            this.showSnackbar("#b71c1c", "Failed to load initial data!");
          }
        })
        .catch((error) => {
          console.error(error);
          this.showSnackbar("#b71c1c", "Network error loading data!");
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },

  mounted() {
    this.onLoad();
  },
};
</script>

<style scoped>
/* General Table Styles */
thead { font-weight: bold !important; }
th { font-weight: bold !important; }
tr, td, th { 
  border: 1px solid black; 
  font-size: small; 
}
td { font-size: small; }

/* Print Styles - CRITICAL FIX */
@media print {
  /* Hide everything except print area */
  body * {
    visibility: hidden !important;
  }
  
  #print-area, #print-area * {
    visibility: visible !important;
  }
  
  #print-area {
    position: absolute !important;
    left: 0 !important;
    top: 0 !important;
    width: 100% !important;
  }

  /* Page setup */
  @page {
    size: A4 landscape;
    margin: 8mm !important;
  }

  /* Table formatting */
  .report-table {
    width: 100% !important;
    font-size: 8pt !important;
    page-break-inside: avoid;
    border-collapse: collapse;
  }

  .report-table table {
    width: 100% !important;
    table-layout: fixed !important;
  }

  .report-table td,
  .report-table th {
    border: 1px solid #000 !important;
    font-size: 8pt !important;
    padding: 3px !important;
    word-wrap: break-word;
    line-height: 1.2;
  }

  /* Repeat header */
  .report-table thead {
    display: table-header-group !important;
  }

  /* Hide UI */
  .v-card, .v-toolbar, .v-btn, .v-input, .no-display {
    display: none !important;
  }

  .v-container {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>